import { Suspense, lazy } from 'react';
import { createBrowserRouter, createRoutesFromElements, Route } from 'react-router-dom';
import LoadingCircularProgress from '~/components/LoadingCircularProgress';
import App from '~/App';
import LayoutWrapper from '~/components/Layouts/LayoutWrapper';

// pages
const RiotAuthOkta = lazy(() => import('../components/User/RiotAuthOkta'));
const RiotAuthOktaCallback = lazy(() => import('../components/User/RiotAuthOktaCallback'));
const OktaAuth = lazy(() => import('../components/User/OktaAuth'));
const OktaAuthCallback = lazy(() => import('../components/User/OktaAuthCallback'));
const LoginPage = lazy(() => import('../components/User/LoginPage'));
const ProtectedRouter = lazy(() => import('./ProtectedRouter'));
const ForgotPasswordPage = lazy(() => import('../components/User/ForgotPasswordPage'));
const ResetPasswordPage = lazy(() => import('../components/User/ResetPasswordPage'));
const VerifyEmailPage = lazy(() => import('../components/User/VerifyEmailPage'));
const SignUpPage = lazy(() => import('../components/User/SignUpPage'));
const LoginWithToken = lazy(() => import('../components/User/LoginWithToken'));
// pages

export const marqCommerceClientRouter = createBrowserRouter(
  createRoutesFromElements(
    <Route element={<App />}>
      <Route
        path="/auth/okta"
        element={
          <Suspense fallback={<LoadingCircularProgress open />}>
            <RiotAuthOkta />
          </Suspense>
        }
      />
      <Route
        path="/auth/okta-callback"
        element={
          <Suspense fallback={<LoadingCircularProgress open />}>
            <RiotAuthOktaCallback />
          </Suspense>
        }
      />
      <Route
        path="/okta/auth"
        element={
          <Suspense fallback={<LoadingCircularProgress open />}>
            <OktaAuth />
          </Suspense>
        }
      />
      <Route
        path="/okta/callback"
        element={
          <Suspense fallback={<LoadingCircularProgress open />}>
            <OktaAuthCallback />
          </Suspense>
        }
      />
      <Route
        path="/dashboard/:access_token/:refresh_token/:opscc_user"
        element={
          <Suspense fallback={<LoadingCircularProgress open />}>
            <LoginWithToken />
          </Suspense>
        }
      />
      <Route
        path="/"
        element={
          <Suspense fallback={<LoadingCircularProgress open />}>
            <LoginPage />
          </Suspense>
        }
      />
      <Route
        path="/login"
        element={
          <Suspense fallback={<LoadingCircularProgress open />}>
            <LoginPage />
          </Suspense>
        }
      />
      <Route
        path="/resetpw"
        element={
          <Suspense fallback={<LoadingCircularProgress open />}>
            <ForgotPasswordPage />
          </Suspense>
        }
      />
      <Route
        path="/resetpw/:token"
        element={
          <Suspense fallback={<LoadingCircularProgress open />}>
            <ResetPasswordPage />
          </Suspense>
        }
      />
      <Route
        path="/verifyEmail/:token"
        element={
          <Suspense fallback={<LoadingCircularProgress open />}>
            <VerifyEmailPage />
          </Suspense>
        }
      />
      <Route
        path="/signup/:token"
        element={
          <Suspense fallback={<LoadingCircularProgress open />}>
            <SignUpPage />
          </Suspense>
        }
      />
      <Route
        path="/*"
        element={
          <LayoutWrapper>
            <Suspense fallback={<LoadingCircularProgress open />}>
              <ProtectedRouter />
            </Suspense>
          </LayoutWrapper>
        }
      />
    </Route>
  )
);
